import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { getReportsHistory } from "api/report.js";
import { ReportStrings } from "constants/constantStrings";

import AgTable from "components/AgTable";
import BadgeLabel from "components/BadgeLabel";
import Filter from "components/Filter";
import PageLoading from "components/PageLoading";
import TextWithRightArrow from "components/TextWithRightArrow";
import { getReportsHistoryTableColDefs } from "./ReportHistory.table.config";

import "./index.scss";

const ReportsHistory = props => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [reportsHistory, setReportsHistory] = useState({});
  const [filterValue, setFilterValue] = useState("");
  const [showTableFilterIcon, setShowTableFilterIcon] = useState(false);
  const [reportsCount, setReportsCount] = useState();
  const TABLE_COL_DEFS = getReportsHistoryTableColDefs(showTableFilterIcon);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getReportsHistory();
        if (response.status >= 200 && response.status < 300 && response?.data?.Reports) {
          const { Reports } = response.data;
          setReportsHistory(Reports);
          setReportsCount(Reports.length);
        }
      } catch (err) {
        console.log("Error: ", err);
        setReportsHistory([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const backButtonHandler = () => navigate(-1);

  return (
    <div className="report-history__container">
      {isLoading ? (
        <PageLoading />
      ) : (
        <>
          <div className="flex-between marginBtm20">
            <BadgeLabel badgeDescription={ReportStrings.reportHistory} badgeText={reportsCount} />
            <TextWithRightArrow text={ReportStrings.backToReport} onClick={backButtonHandler} />
          </div>
          <div className="flex-between marginBtm20">
            <span className="descriptionText">{ReportStrings.pastReportsAtOnePlace}</span>
            <div className="jc-end">
              <Filter
                data={reportsHistory}
                setFilterValue={setFilterValue}
                setShowTableFilterIcon={setShowTableFilterIcon}
                showTableFilterIcon={showTableFilterIcon}
                customClass="marginBtm10"
              />
            </div>
          </div>
          <AgTable
            rowData={reportsHistory}
            columnDefs={TABLE_COL_DEFS}
            quickFilterText={filterValue}
            setShowTableFilterIcon={setShowTableFilterIcon}
            showTableFilterIcon={showTableFilterIcon}
            setBadgeCount={setReportsCount}
            customHeight="calc(100vh - 210px)"
          />
        </>
      )}
    </div>
  );
};

export default ReportsHistory;
